import React, { useState } from "react";
import { Box, Button, Typography, Container, useTheme } from "@mui/material";
import FeedbackIcon from "@mui/icons-material/Feedback";
import FeedbackForm from "./FeedbackForm";

const Footer = () => {
  const [showFeedback, setShowFeedback] = useState(false);
  const theme = useTheme();

  return (
    <>
      <Box
        component="footer"
        sx={{
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
          py: 0,
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 1200,
          boxShadow: "0 -1px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="textSecondary">
            &copy; {new Date().getFullYear()} Chef Chatty.
          </Typography>
          <Button
            variant="text"
            size="small"
            startIcon={<FeedbackIcon />}
            onClick={() => setShowFeedback(true)}
          >
            What do you think?
          </Button>
        </Container>
      </Box>

      <FeedbackForm
        open={showFeedback}
        onClose={() => setShowFeedback(false)}
      />
    </>
  );
};

export default Footer;
